import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

/** @deprecated exporting for backwards compatability */
export { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/common-components/styles";

export const StyledDropdownContainer = styled.div`
    position: relative;
`;

//TODO remove in favour of pages/sales-intelligence/common-components/styles withSWReactIconFillColor
export const withSWReactIconFillColor = (color: string) => css`
    & ${SWReactIcons} {
        svg path {
            fill: ${color};
        }
    }
`;
